<template>
  <ul class="mobile-navigation">
    <NavigationItem
      v-for="route in routes"
      class="mobile-navigation__item"
      :key="route.link.value.text"
      :hasChildren="isSubNav(route)"
    >
      <span
        v-if="isSubNav(route)"
        tabindex="0"
        @click="setActiveItem(VIEWS.MobileSubNav, route)"
        @keydown.enter.space="setActiveItem(VIEWS.MobileSubNav, route)"
      >
        {{ route.link.value.text }} <ShIcon size="xsmall" name="arrowRight" class="mobile-navigation__subnav-icon" :stroke="subMenuArrowStroke" />
      </span>
      <ShLink
        v-else
        :to="route.link.value.href"
        :target="route.link.value.target"
      >
        {{ route.link.value.text }}
      </ShLink>
    </NavigationItem>
    <NavigationItem
      v-if="!currentUser"
      class="mobile-navigation__item mobile-navigation--bottom"
    >
      <sh-button
        :fullWidth="true"
        @click.stop="setActiveItem(VIEWS.MobileSubscription)"
      >
        {{ $t('SUBSCRIBE_TITLE') }}
      </sh-button>
    </NavigationItem>
    <NavigationItem
      v-if="!currentUser"
      class="mobile-navigation__item"
    >
      <ShButton :fullWidth="true" :outline="true" role="link" @click="signIn">
        {{ $t('NAV_SIGN_IN') }}
      </ShButton>
    </NavigationItem>
    <NavigationItem
      :hasChildren="true"
      :class="[
        'mobile-navigation__item',
        'mobile-navigation--bottom-margin',
        { 'mobile-navigation--bottom': currentUser }
      ]"
    >
      <span
        tabindex="0"
        @click="setActiveItem(VIEWS.MobileSubNav, languageRoute)"
        @keydown.enter.space="setActiveItem(VIEWS.MobileSubNav, languageRoute)"
      >
        {{ $t('NAV_LANGUAGE') }} <ShIcon size="xsmall" name="arrowRight" class="mobile-navigation__subnav-icon" :stroke="subMenuArrowStroke" />
      </span>
    </NavigationItem>
  </ul>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from 'vuex'
import { NavigationItem, ShIcon } from '@sohohouse/design-system'

import ShLink from '~/components/sh-link'
import { VIEWS } from '~/constants/navbar-views'

const { mapState: mapEnvState, mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  nmae: 'MobileNav',

  components: {
    NavigationItem,
    ShIcon,
    ShLink
  },

  props: {
    routes: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  data () {
    return {
      VIEWS
    }
  },

  computed: {
    ...mapGetters(['currentUser']),
    ...mapEnvState(['languages']),
    ...mapEnvGetters(['isDarkTheme']),

    languageRoute () {
      const items = this.languages.map(lang => ({
        link: {
          value: {
            text: lang.t,
            code: lang.code,
            target: ''
          }
        }
      }))

      return { link: { value: { text: this.$t('NAV_MOBILE_LANGUAGE_TITLE') } }, items }
    },

    subMenuArrowStroke () {
      return this.isDarkTheme ? 'white' : 'black'
    }
  },

  methods: {
    isSubNav (link) {
      return link.items.length > 0
    },

    setActiveItem (component, link = {}) {
      this.$emit('navigation:active', component, link)
    },

    signIn () {
      this.$login()
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-navigation {
  margin: 0 $space-060;
  padding: 0;
  min-height: 100%;
  display: flex;
  flex-direction: column;

  &__item {
    margin-bottom: $space-060;

    > span {
      display: flex;
      width: 100%;
    }
  }

  &__subnav-icon {
    margin-left: auto;
    align-self: center;
  }

  &--bottom {
    margin-top: auto;
  }

  &--bottom-margin {
    margin-bottom: $space-110;
  }
}
</style>
